var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"78","height":"92","viewBox":"0 0 78 92","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 91.5H26V0.5H0V91.5ZM52 0.5V91.5H78V0.5H52Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }